import CreateCampaignPartial from "../../partials/campaign/create-campaign.partial";

export default function CreateCampaignScreen() {
  return <CreateCampaignPartial />;
}
